import { removeNamespace } from '@/utils/helpers'
import ImprintService from '@/services/imprint.service'

export const IMPRINTS_TYPES = {
  mutations: {
    SET_LOADING: 'imprints/SET_LOADING',
    SET_FORMATS: 'imprints/SET_FORMATS',
    SET_PAGED_IMPRINTS: 'imprints/SET_PAGED_IMPRINTS',
    SET_TOTAL_IMPRINTS_COUNT: 'imprints/SET_TOTAL_IMPRINTS_COUNT',
    SET_IMPRINTS_TABLE_OPTIONS: 'imprints/SET_IMPRINTS_TABLE_OPTIONS',
    SET_IMPRINTS_SEARCH_OPTIONS: 'imprints/SET_IMPRINTS_SEARCH_OPTIONS',
    SET_SELECTED_IMPRINT: 'imprints/SET_SELECTED_IMPRINT',
    SET_SELECTED_IMPRINT_FORMAT: 'imprints/SET_SELECTED_IMPRINT_FORMAT'
  },
  actions: {
    fetchImprintsPaged: 'imprints/fetchImprintsPaged',
    fetchImprint: 'imprints/fetchImprint',
    fetchFormats: 'imprints/fetchFormats',
    fetchTenants: 'imprints/fetchTenants',
    setFormat: 'imprints/setFormat',
    saveImprint: 'imprints/saveImprint',
    saveImprintTenants: 'imprints/saveImprintTenants'
  }
}

const _types = removeNamespace('imprints', IMPRINTS_TYPES)

const state = () => ({
  loading: false,
  formats: [],
  imprintsTableOptions: {
    page: 1,
    itemsPerPage: 10
  },
  imprintsSearchOptions: {
    keyword: '',
    importFilter: null
  },
  pagedImprints: [],
  totalImprintsCount: 0,
  selectedImprint: {}
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_FORMATS] (state, result) {
    state.formats = result
  },
  [_types.mutations.SET_PAGED_IMPRINTS] (state, pagedResult) {
    state.pagedImprints = pagedResult
  },
  [_types.mutations.SET_TOTAL_IMPRINTS_COUNT] (state, count) {
    state.totalImprintsCount = count
  },
  [_types.mutations.SET_IMPRINTS_TABLE_OPTIONS] (state, options) {
    state.imprintsTableOptions = options
  },
  [_types.mutations.SET_IMPRINTS_SEARCH_OPTIONS] (state, options) {
    state.imprintsSearchOptions = options
  },
  [_types.mutations.SET_SELECTED_IMPRINT] (state, imprint) {
    state.selectedImprint = imprint
  },
  [_types.mutations.SET_SELECTED_IMPRINT_FORMAT] (state, format) {
    state.selectedImprint.format = format
    state.selectedImprint.productFormatId = format.id
  }
}

const actions = {
  [_types.actions.fetchImprintsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const { itemsPerPage, page } = state.imprintsTableOptions
    const { keyword, importFilter } = state.imprintsSearchOptions
    const dataSourceId = state.imprintsSearchOptions.dataSource ? state.imprintsSearchOptions.dataSource.id : null
    const maxResultCount = itemsPerPage
    const skipCount = (page - 1) * itemsPerPage
    ImprintService.getImprintsPaged(skipCount, maxResultCount, keyword, dataSourceId, importFilter)
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_IMPRINTS, items)
        commit(_types.mutations.SET_TOTAL_IMPRINTS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchImprint] ({ state, commit }, id) {
    commit(_types.mutations.SET_LOADING, true)
    return ImprintService.getImprintById(id)
      .then((res) => {
        commit(_types.mutations.SET_SELECTED_IMPRINT, res)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.saveImprint] ({ state, commit }, imprint) {
    commit(_types.mutations.SET_LOADING, true)
    return ImprintService.updateImprint(imprint)
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.saveImprintTenants] ({ commit }, { id, tenants }) {
    commit(_types.mutations.SET_LOADING, true)
    return ImprintService.updateImprintTenants(id, tenants)
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
